export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  VIEWER = 'viewer',
}

/** True for roles that may manage users, connections and trigger collections. */
export function isAdminRole(role: string | undefined | null): boolean {
  return role === UserRole.ADMIN || role === UserRole.SUPER_ADMIN
}

export interface User {
  id: string
  email: string
  first_name: string
  last_name: string
  full_name: string
  avatar_url?: string
  phone?: string
  department?: string
  job_title?: string
  role: UserRole
  is_active: boolean
  is_verified: boolean
  is_oauth_user?: boolean
  oauth_provider?: string
  theme_preference: 'light' | 'dark' | 'system'
  language: string
  timezone: string
  totp_enabled?: boolean
  created_at: string
  updated_at?: string
  last_login_at?: string
}

export interface UserUpdate {
  email?: string
  first_name?: string
  last_name?: string
  phone?: string
  department?: string
  job_title?: string
  theme_preference?: 'light' | 'dark' | 'system'
  language?: string
  timezone?: string
  is_active?: boolean
  role?: UserRole
}